import { USER_ROLE } from './constants';

/**
 * Returns the parsed new roles
 * - MEMBER => BROADCASTER
 *
 * @param {any} defaultValue - Default value to be returned
 * @returns {String}
 */

const LEGACY_BROADCASTER_ROLE = 'MEMBER';

export default function normalizeAccountRole(role) {
  return role === LEGACY_BROADCASTER_ROLE ? USER_ROLE.BROADCASTER : role;
}
